<kendo-formfield class="form-field" [formGroup]="formgroup!">
    <kendo-floatinglabel [text]="t7eLabel">
        <kendo-multiselect #depts class="ddStatus" [formControl]="statusFC!" [data]="statuses" textField="name"
            valueField="id" name="statuses" [checkboxes]="true" [autoClose]="false" fillMode="flat">
        </kendo-multiselect>
    </kendo-floatinglabel>
</kendo-formfield>